var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-logo",on:{"click":_vm.goToHome}},[_c('img',{attrs:{"src":_vm.logo === 'dark'
        ? require('@/assets/logos/s1_b_logo.png')
        : require('@/assets/logos/s1_w_logo.png')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }